<template>
  <NuxtLayout>
    <CustomLoadingIndicator />
    <NuxtRouteAnnouncer />
    <NuxtPage />
  </NuxtLayout>
</template>
